import { logInfo } from 'utils/logging';

const LogoutRequest = async () => {
  const _req = {
    query: `
      mutation {
        userLogOut(
            input: {

            }
          ) {

          payload {
            success
          }
        }
      }`,
  };

  try {
    const response = await fetch(`/teens/gateway`, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(_req),
    });
    return response.json();
  } catch (error: any) {
    logInfo(error.toString(), true);
  }
};

export default LogoutRequest;
